import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StoreProvider, ThemeProvider } from '@dreamtree-org/twreact-ui';
import '@dreamtree-org/twreact-ui/dist/index.css';
import './theme/tokens.css';
import './index.css';
import App from './App.jsx';
import { restoreBrand } from './theme/applyTheme';
import { loadDomainConfig } from './lib/domainResolver';
import { loadMode } from './lib/tenantAuth';
import { ToastProvider } from './lib/toast';
import { registerSW } from 'virtual:pwa-register';

// In `autoUpdate` mode this listens for the new worker's 'activated' event and reloads
// the page exactly once, so a deploy can never strand a browser on the previous bundle
// (vite-plugin-pwa/dist/client/build/register.js). Registering here rather than through
// the plugin's injected script is what buys that listener — see vite.config.js.
registerSW({ immediate: true });

// Apply any saved per-tenant brand before first paint (runtime theming).
restoreBrand();

// Resolve this deployment's api_base (config/domain.resolver.js, served at
// /api/config/domains) before first render so useAppApi's axios instance picks it up.
// Never throws — a same-origin deployment resolves to "" and behaves exactly as before.
// The sign-in mode (company sign-in vs legacy) must be known before the first route renders.
loadDomainConfig().then(() => loadMode()).finally(() => {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <StoreProvider>
        <ThemeProvider>
          <ToastProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ToastProvider>
        </ThemeProvider>
      </StoreProvider>
    </React.StrictMode>
  );
});
